// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1yXRq","subheader":"ReorderModal_subheader__20o5Z","listWrap":"ReorderModal_listWrap__1UOuA"};